import React from 'react';
import { withRouter } from 'react-router-dom';
import ConfirmCodeForm from '../../forms/ConfirmCodeForm';
import connect from "react-redux/es/connect/connect";
import { confirmVerificationCodeAction } from "../../../redux/actions/profile.actions";

const ConfirmCodePage = ({ registration, confirmVerificationCodeAction }) => (
  <div
    id="page-container"
    className="row align-items-center justify-content-center"
  >
    <ConfirmCodeForm
      headerText="Confirm number"
      errors={registration.errors}
      confirmCodeAction={confirmVerificationCodeAction}
    />
  </div>
);

const mapStateToProps = ({ profile }) => ({
  registration: profile.registration
});


export default withRouter(
  connect(
    mapStateToProps,
    { confirmVerificationCodeAction }
  )(ConfirmCodePage)
);


// WEBPACK FOOTER //
// ./src/components/pages/ConfirmCodePage/ConfirmCodePage.jsx